import { render, staticRenderFns } from "./ShareLinkDialog.vue?vue&type=template&id=3c3128a1"
import script from "./ShareLinkDialog.vue?vue&type=script&lang=js"
export * from "./ShareLinkDialog.vue?vue&type=script&lang=js"
import style0 from "./ShareLinkDialog.vue?vue&type=style&index=0&id=3c3128a1&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c3128a1')) {
      api.createRecord('3c3128a1', component.options)
    } else {
      api.reload('3c3128a1', component.options)
    }
    module.hot.accept("./ShareLinkDialog.vue?vue&type=template&id=3c3128a1", function () {
      api.rerender('3c3128a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ShareLinkDialog.vue"
export default component.exports